exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Iframe1 .placeholder{width:100%;height:100%;color:#999;background-color:#f9f9f9}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/Iframe1/src/components/contents/Iframe1/Iframe1.s.scss"],"names":[],"mappings":"AAEA,sBAEI,WAAW,AACX,YAAY,AACZ,WAAW,AACX,wBAAyB,CAC1B","file":"Iframe1.s.scss","sourcesContent":["@import '~scss/variables';\n\n.Iframe1 {\n  .placeholder {\n    width: 100%;\n    height: 100%;\n    color: #999;\n    background-color: #f9f9f9;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/Iframe1/Iframe1.s.scss
// module id = 977
// module chunks = 123